import * as React from 'react';
import { ButtonCallToAction, ButtonTertiary, ValidationProps } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeListItem, CodeListModifiedComments, CodeListModifiedFactor } from 'app/area/indicator-factors/list/types-store';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import { AccessCodes, CodetableAccess } from 'app/area/indicator-factors/types-store';
import { getModifiedItemsLength } from 'app/area/indicator-factors/list/list-items/get-modified-items-length';
import styles from './indicator-factors-header.scss';

interface TextListHeaderProps {
  data: CodeListItem[];
  fetchingData: boolean;
  numberOfResults: number;
  modifiedFactors: CodeListModifiedFactor[];
  modifiedComments: CodeListModifiedComments[];
  saveChanges: () => void;
  cancelChanges: () => void;
  codetableAccess: CodetableAccess;
  itemAccesses: AccessCodes[];
  validation: { [key: string]: ValidationProps };
  translation: CodetableTranslation;
}

export const IndicatorFactorsListHeader: React.FC<TextListHeaderProps> = ({
  data, fetchingData, numberOfResults, modifiedFactors, modifiedComments,
  codetableAccess, itemAccesses, saveChanges, cancelChanges, validation, translation
}) => {

  if (!data) {
    return null;
  }

  const allValid = (validation?.text?.messages?.length ?? 0) === 0 &&
  modifiedFactors.every(item => isDefinedIncludingZero(item.factor));
  const modifiedItemsLength = getModifiedItemsLength(modifiedFactors, modifiedComments);
  const hasChanges = modifiedItemsLength > 0;
  const canEdit = !!codetableAccess?.codetables?.administrationCentral
    || (itemAccesses?.some(access => access.edit) ?? false);

  return <>
    <div className={styles.header}>
      <div className={styles.leftContent}>
        <span id="indicator_factors_number_of_results">
          {numberOfResults === 0
            ? translation.search_no_hits
            : `${numberOfResults} ${translation.search_hits}`}
        </span>
        {fetchingData && <div className={styles.spinLoader} />}
      </div>
      <div>
        {hasChanges &&
          <span id="indicator_factors_number_of_modified">
            {modifiedItemsLength} {translation.modified_codes}
          </span>}
        {canEdit && <>
          <ButtonTertiary
            id="indicator_factors_cancel_changes"
            onClick={cancelChanges}
            disabled={!hasChanges}>
            {translation.cancel_changes}
          </ButtonTertiary>
          <ButtonCallToAction
            id="indicator_factors_save_changes"
            onClick={saveChanges}
            disabled={!hasChanges || !allValid}>
            {translation.update_codes}
          </ButtonCallToAction>
        </>}
      </div>
    </div>
  </>;
};
